import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000
});

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('no_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(r => r, err => {
  const status = err.response?.status;
  if (status === 401) {
    localStorage.removeItem('no_token');
    localStorage.removeItem('no_user');
    if (!window.location.pathname.startsWith('/login')) window.location.href = '/login';
  } else if (!err.config?.silent) {
    // Surface server/network errors globally so no failure passes silently.
    const message = err.response?.data?.error
      || (err.code === 'ECONNABORTED' ? 'Request timed out. Please try again.'
      : !err.response ? 'Cannot reach the server. Check your connection.'
      : status >= 500 ? 'Something went wrong on the server.'
      : null);
    if (message) {
      window.dispatchEvent(new CustomEvent('api-error', { detail: { message, status } }));
    }
  }
  return Promise.reject(err);
});

export default api;
